import { render, staticRenderFns } from "./cardComponent.vue?vue&type=template&id=ca5204b6"
import script from "./cardComponent.vue?vue&type=script&lang=js"
export * from "./cardComponent.vue?vue&type=script&lang=js"
import style0 from "./cardComponent.vue?vue&type=style&index=0&id=ca5204b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports